import { useEffect, useMemo, useReducer } from 'react';
import { createDraftBuffer } from '../utils/draftBuffer';

export default function useDraftBuffer(userId, recordId, kind) {
  const [, redraw] = useReducer(value => value + 1, 0);
  const buffer = useMemo(() => {
    let storage;
    try { storage = window.sessionStorage; } catch {
      storage = { getItem() { throw new Error('Storage unavailable'); }, setItem() { throw new Error('Storage unavailable'); }, removeItem() { throw new Error('Storage unavailable'); } };
    }
    return createDraftBuffer(`audit-pro:recovery:v1:${userId}:${recordId}:${kind}`, storage);
  }, [userId, recordId, kind]);
  useEffect(() => {
    buffer.active = true;
    const unsubscribe = buffer.subscribe(redraw);
    return () => { buffer.active = false; unsubscribe(); };
  }, [buffer]);
  useEffect(() => {
    const protect = event => {
      if (!buffer.count && !buffer.recovery) return;
      event.preventDefault();
      event.returnValue = '';
    };
    window.addEventListener('beforeunload', protect);
    return () => window.removeEventListener('beforeunload', protect);
  }, [buffer]);
  return buffer;
}
